import { z } from 'zod'

export const MEMBERSHIP_I18N_READ_CONTRACT_VERSION = '1.0.0' as const

/** Query parsing stays deliberately permissive; handlers retain legacy validation/status precedence. */
export const membershipI18nReadQuerySchema = z.object({
  locale: z.string().optional(),
  orgId: z.string().optional(),
}).passthrough()

export const membershipI18nKeysResponseSchema = z.object({
  keys: z.record(z.string()),
}).passthrough()

export const membershipI18nSkinResponseSchema = z.object({
  tokens: z.record(z.string()),
}).passthrough()

export type MembershipI18nKeysResponse = z.infer<typeof membershipI18nKeysResponseSchema>
export type MembershipI18nSkinResponse = z.infer<typeof membershipI18nSkinResponseSchema>
